export default "__VITE_ASSET___Ocdkddo__"